// momentjs formats: https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/
const DATE_FORMAT = 'MMM. DD, YYYY';
const DATE_TIME_FORMAT = 'MMM. DD, YYYY HH:mm:ss';
const TIME_FORMAT = 'HH:mm:ss';

export {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  TIME_FORMAT
}